var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AppProgress',{attrs:{"current":_vm.currentStep,"total":_vm.components.length}}),_c('transition',{attrs:{"name":_vm.transition,"mode":"out-in"}},[_c(_vm.component,{tag:"component"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }